export default{
    msg:'',
    editar:{},
    lista:'',
    pesquisa:'',
    matricula:'',
}